export default __webpack_public_path__ + "static/media/restaurant-app.7c194106.png";